import script from "./UniqueChoiceScene.vue?vue&type=script&lang=js"
export * from "./UniqueChoiceScene.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__